/**
 * Created by idea on 06/04/2017.
 */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {
  route: any = {};
  constructor(private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const url = next.routeConfig.path;
    const data = next.routeConfig.data;
    // let isShop = localStorage.getItem('isShop');
    const timestamp = Math.round(Date.now() / 1000);

    // var arrayIsShop = ['product','product/add','order/shop','order_free','customers_shop','vendors','brands','shipping','bill_info','history/warehouse','history/payment','dashboard','income_shop', 'sprofile'];

    if (!this.isAuthenticated()) {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/login'], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
    if (localStorage.getItem('Access-Token') && localStorage.getItem('Access-Token-Icheck')) {
      const user_info = JSON.parse(localStorage.getItem('User'));

      if (data && data.role) {
        if (data.role.indexOf(user_info.role) === -1) {
          this.router.navigate(['/search/ticket']);
          return false;
        }
      }
      return true;
    }

    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  isAuthenticated() {
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    return Date.now() + 60000 < expiresAt;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Auth.guard.ts